export const ROLE_CONFIG = {
  "vf-admin": {
    label: "VF-Admin",
    bgColor: "bg-verba-blue dark:bg-verba-blue-dk",
  },
  "vf-editor": {
    label: "VF-Editor",
    bgColor: "bg-retrying-status dark:bg-retrying-status-dk",
  },
  "vf-viewer": {
    label: "VF-Viewer",
    bgColor: "bg-lead-stage-enquiries dark:bg-lead-stage-enquiries-dk",
  },
  superadmin: {
    label: "Super Admin",
    bgColor: "bg-verba-green-success dark:bg-verba-green-success-dk",
  },
  admin: {
    label: "Admin",
    bgColor: "bg-rating-yellow dark:bg-rating-yellow-dk",
  },
  editor: {
    label: "Editor",
    bgColor: "bg-analytics-peach dark:bg-analytics-peach-dk",
  },
  commentor: {
    label: "Commentor",
    bgColor: "bg-analytics-safety dark:bg-analytics-safety-dk",
  },
  viewer: {
    label: "Viewer",
    bgColor: "bg-analytics-gray dark:bg-analytics-gray-dk",
  },
};
